/** Search params of record cards: the open tab and, on the «Договор» tab, the contract. */
export interface CardSearch {
  readonly tab?: string;
  readonly contract?: string;
}

export function validateCardSearch(search: Record<string, unknown>): CardSearch {
  return {
    ...(typeof search.tab === 'string' ? { tab: search.tab } : {}),
    ...(typeof search.contract === 'string' ? { contract: search.contract } : {}),
  };
}
